/* eslint-disable prettier/prettier */
/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
import EmailIcon from "@material-ui/icons/Email";
import PhoneEnabledRoundedIcon from "@material-ui/icons/PhoneEnabledRounded";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import { CircularProgress, Modal, Typography, Button } from "@material-ui/core";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import client from "apollo/client";
import { SendApplicationDocument } from "graphqlBase/misc/__generated__/sendApplication";
import CongratulationSVG from "icons/components/Congratulations";
import {
  BewerberCreateForm,
  BewerberCreateOnUpdateDataMiddleWare,
  BewerberCreateOnUpdateDataMiddleWareProps,
} from "raft/BewerberForm";
import { useUploadfileTypeCallback } from "components/formElements/fields/fileUpload/fileState";
import React, { useState } from "react";
import { Helmet } from "react-helmet";
import translations from "translations";
import validateForm2 from "./validateForm";
import { useUploadDocumentsMutation } from "graphqlBase/Beweber/__generated__/uploadDocuments";
import { AttachementInput } from "graphqlBase/types";
import {
  GetNamesForIdsForHubSpotDocument,
  GetNamesForIdsForHubSpotQueryVariables,
  GetNamesForIdsForHubSpotQuery,
} from "graphqlBase/Beweber/__generated__/getNamesForIdsForHubSpot";
const localStorageKey = "applicationKo";
const hubSpotApiUri =
  "https://api.hsforms.com/submissions/v3/integration/submit/20233320/62ee77d7-069d-487d-8c87-0b7d970ea454";

const useStyles = makeStyles<Theme>(
  (theme) =>
    createStyles({
      bewerberCreateFormBox: {
        margin: "0 auto",
        padding: "0 1em",
        maxWidth: "100%",
        display: "flex",
        flexDirection: "column",
        // height: "100%",
      },
      modal: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      },
      paper: {
        backgroundColor: theme.palette.background.paper,
        border: "2px solid #000",
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
        height: "100%",
        width: "100%",
        display: "flex",
        justifyContent: "center",
      },
      progress: {
        top: "6%",
        left: "50%",
        width: "3%",
        color: theme.colors.brandYellow,
        position: "absolute",
      },
      afterCreate: {
        margin: "auto",
        maxWidth: "800px",
        marginTop: "2.5em",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      },
      afterCreateBody: {
        marginTop: "1em",
        color: theme.colors.mineShaftBlack,
        fontSize: "18px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      },
      afterCreateHeadline: { marginBottom: "10px", fontWeight: 700, fontSize: "35px", color: theme.colors.smaltBlue },
      afterCreateSubHeadline: { fontWeight: 400, color: theme.colors.gumboTeal, fontSize: "25px" },
      linkContainer: { display: "flex", marginTop: "1em", color: theme.colors.sunYellow },
      linkTypography: { marginLeft: "15px", color: theme.colors.mineShaftBlack, fontSize: "18px" },
      link: {
        color: theme.colors.mineShaftBlack,
        "&:hover": {
          textDecoration: "underline",
        },
      },
      svgContainer: { width: "12em", height: "12em", marginBottom: "2em" },
      noMargin: { margin: 0 },
      errorContainer: {
        margin: "auto",
        maxWidth: "800px",
        marginTop: "2.5em",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        padding: "2em",
        backgroundColor: "#ffebee",
        borderRadius: "8px",
        border: "1px solid #ffcdd2",
      },
      errorHeadline: {
        marginBottom: "10px",
        fontWeight: 700,
        fontSize: "28px",
        color: "#d32f2f",
        textAlign: "center",
      },
      errorMessage: {
        marginTop: "1em",
        color: "#d32f2f",
        fontSize: "16px",
        textAlign: "center",
        lineHeight: 1.5,
      },
      retryButton: {
        marginTop: "2em",
        padding: "12px 24px",
        backgroundColor: theme.colors.brandYellow,
        color: theme.colors.mineShaftBlack,
        border: "none",
        borderRadius: "4px",
        fontSize: "16px",
        fontWeight: 600,
        cursor: "pointer",
        "&:hover": {
          backgroundColor: theme.colors.sunYellow,
        },
      },
    }),

  { name: `Pages-Home` }
);

type Data = BewerberCreateOnUpdateDataMiddleWareProps["data"];

const getPersisted = () => {
  try {
    return JSON.parse(window.window.localStorage.getItem(localStorageKey) ?? '{"step": 0}');
  } catch (e) {
    return { step: 0, loaded: true };
  }
};

const onUpdateDataMiddleWare: BewerberCreateOnUpdateDataMiddleWare = (props) => {
  const data = (!props.data.loaded ? getPersisted() : { loaded: true }) as Data;

  const validated = validateForm({ ...props, data: { ...data, ...props.data } });
  const dataStore = { ...data, ...props.data, ...validated };

  window.localStorage.setItem(localStorageKey, JSON.stringify(dataStore));
  return {
    ...data,
    ...validated,
    loaded: true,
    // stringyfiedData: JSON.stringify({ ...props.data, ...data, ...validated }),
  };
};

const validateForm: BewerberCreateOnUpdateDataMiddleWare = ({ data, changedFields, dataBefore, ...rest }) => {
  const hasStepIncreased = (data.step ?? 0) > (dataBefore.step ?? 0);
  const hasStepDecreased = (data.step ?? 0) < (dataBefore.step ?? 0);

  if (hasStepIncreased || data.submit || data.formHasErrors) {
    const formErrors = validateForm2(data, (hasStepIncreased ? dataBefore.step : data.step) as 0 | 1 | 2 | 3 | 4);
    const hasErrors = !!formErrors && Object.values(formErrors).some((v) => !!v?.length);

    return {
      formErrors: formErrors ?? { nope: [] },
      formHasErrors: hasErrors ? 1 : 0,
      submit: hasErrors ? false : data.submit,
      step: hasStepDecreased
        ? data.step
        : hasErrors
        ? dataBefore.step
        : (dataBefore.step ?? 0) + (hasStepIncreased ? 1 : 0),
      zahlungsdatum: "2021-01-01T00:00:00.001",

      strasse: data.strasse || "",
      hausnummer: data.hausnummer || "",
      plz: data.plz || "",
      wohnort: data.wohnort || "",
      telefonnummer: data.telefonnummer || "",
      newsletterAccepted: data.newsletterAccepted || false,
    };
  }

  return {};
};

const getNamesForHubSpot = async (data: Data) => {
  const result = await client.query<GetNamesForIdsForHubSpotQuery, GetNamesForIdsForHubSpotQueryVariables>({
    query: GetNamesForIdsForHubSpotDocument,
    variables: {
      zahlungsmodellId: data.zahlungsmodellId,
      studiengangSemesterId: data.studiengangSemesterId ?? 0,
      geschlechtId: data.geschlechtId,
    },
  });
  const resultData = result.data;
  return {
    zahlungsModell:
      resultData?.zahlungsmodells[0]?.id === 2
        ? "410,- € monatlich (Laufzeit: 42 Monate, Gesamtgebühr: 17.220,- €)"
        : resultData?.zahlungsmodells[0]?.id === 1
        ? "Einmalig (Gesamtgebühr: 16.700,- €)"
        : resultData?.zahlungsmodells[0]?.id === 9
        ? "410,- € monatlich (Laufzeit: 42 Monate, Gesamtgebühr: 17.220,- €)"
        : resultData?.zahlungsmodells[0]?.id === 3
        ? "330,- € monatlich (Laufzeit: 54 Monaten, Gesamtgebühr: 17.820,- €)"
        : resultData?.zahlungsmodells[0]?.id === 4
        ? "Einmalig (Gesamtgebühr: 16.245,- €)"
        : resultData?.zahlungsmodells[0]?.id === 5
        ? "480,- € monatlich (Laufzeit: 36 Monate, Gesamtgebühr: 17.280,- €)"
        : resultData?.zahlungsmodells[0]?.id === 7
        ? "Zahlungsmodell in Kooperation mit der Hochschule Weserbergland (Hameln)"
        : resultData?.zahlungsmodells[0]?.id === 10
        ? "330,- € monatlich (Laufzeit: 54 Monate, Gesamtgebühr: 17.820,- €)"
        : resultData?.zahlungsmodells[0]?.id === 8
        ? "Einmalig (Gesamtgebühr: 16.700,- €)"
        : resultData?.zahlungsmodells[0]?.id === 11
        ? "Zahlungsmodell in Kooperation mit der Hochschule Weserbergland (Hameln)"
        : "",

    geschlecht: resultData?.geschlechts[0]?.geschlechtName ?? "",
    studiengang:
      resultData?.studiengangSemesters[0]?.studiengangOnBew?.id === 4
        ? "Gerontologie, Gesundheit & Care B.A."
        : resultData?.studiengangSemesters[0]?.studiengangOnBew?.id === 8
        ? "Gesundheitspsychologie B.A."
        : resultData?.studiengangSemesters[0]?.studiengangOnBew?.id === 2
        ? "Kindheitspädagogik B.A."
        : resultData?.studiengangSemesters[0]?.studiengangOnBew?.id === 6
        ? "Kindheitspädagogik B.A. dual"
        : result.data?.studiengangSemesters[0]?.studiengangOnBew?.id === 1
        ? "Soziale Arbeit B.A. BB"
        : resultData?.studiengangSemesters[0]?.studiengangOnBew?.id === 7
        ? "Soziale Arbeit B.A. dual"
        : resultData?.studiengangSemesters[0]?.studiengangOnBew?.id === 9
        ? "Gesundheitsmanagement B.A."
        : resultData?.studiengangSemesters[0]?.studiengangOnBew?.id === 10
        ? "Physician Assistant B.Sc."
        : resultData?.studiengangSemesters[0]?.studiengangOnBew?.id === 11
        ? "Digital Health B.Sc."
        : resultData?.studiengangSemesters[0]?.studiengangOnBew?.id === 12
        ? "Gesundheits- und Pflegepädagogik B.A."
        : resultData?.studiengangSemesters[0]?.studiengangOnBew?.id === 13
        ? "Pflegepädagogik B.A."
        : resultData?.studiengangSemesters[0]?.studiengangOnBew?.id === 5
        ? "Soziale Arbeit B.A."
        : "",
    studienmodell:
      resultData?.studiengangSemesters[0]?.studiengangOnBew?.studienmodell.id === 2
        ? "Ausbildungs- und Berufsbegleitend"
        : resultData?.studiengangSemesters[0]?.studiengangOnBew?.studienmodell.id === 3
        ? "Duales Studium"
        : resultData?.studiengangSemesters[0]?.studiengangOnBew?.studienmodell.id === 1
        ? "Vollzeit"
        : "",
    studiumArt: resultData?.studiengangSemesters[0]?.semester?.semesterName ?? "",
  };
};

const callHubSpotApi = async (
  data: Data & {
    id: number;
  }
): Promise<boolean> => {
  try {
    const namesFormIds = await getNamesForHubSpot(data);
    const dateTime = new Date(data.geburtsdatum);
    const dateOnly = dateTime.toISOString().split("T")[0] as unknown as Date;

    const body = {
      fields: [
        { name: "wie_mochtest_du_studieren_", value: namesFormIds.studienmodell },
        { name: "fur_welchen_studiengang_interessierst_du_dich_", value: namesFormIds.studiengang },
        { name: "studienstart", value: namesFormIds.studiumArt },
        { name: "zahlungsModell", value: namesFormIds.zahlungsModell },
        { name: "gender", value: namesFormIds.geschlecht },
        { name: "firstname", value: data.vorname },
        { name: "lastname", value: data.nachname },
        { name: "geburtstag", value: dateOnly },
        { name: "geburtsort", value: data.geburtsort },
        { name: "geburtsland", value: data.geburtslandId },
        { name: "staatsangehorigkeit", value: data.staatsangehoerigkeitId },
        { name: "strasse", value: data.strasse },
        { name: "hausnummer", value: data.hausnummer },
        { name: "zip", value: data.plz },
        { name: "city", value: data.wohnort },
        { name: "country", value: data.wohnlandId },
        { name: "phone", value: data.telefonnummer },
        { name: "email", value: data.email },
        { name: "datenschutz_einwilligung", value: data.privacyPolicyAccepted },
        {
          name: "formular_checkbox___e_mail_typ___mit_uns_studieren",
          value: data.newsletterAccepted,
        },
      ],
      context: {
        hutk: getHutk(),
        pageUri: "www.kolping-hochschule.de/bewerbung",
        pageName: "bewerbung",
      },
    };

    const response = await fetch(hubSpotApiUri, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer pat-na1-1b4d8bf1-a422-4c0d-8c4c-4f41901f9293`,
      },
      body: JSON.stringify(body),
    });

    const responseData = await response.json();

    if (!response.ok) {
      console.error("[HubSpot] HTTP Error:", response.status, responseData);
      return false;
    }

    // Check for HubSpot-specific errors in the response
    if (responseData.errors && responseData.errors.length > 0) {
      console.error("[HubSpot] HubSpot API Error:", responseData.errors);
      return false;
    }

    // Check if the submission was successful
    if (responseData.status === "error" || responseData.statusCode === 400) {
      console.error("[HubSpot] Submission failed:", responseData.message || responseData);
      return false;
    }

    return true;
  } catch (error) {
    console.error("[HubSpot] Exception occurred:", error);
    return false;
  }
};
const getHutk = () => {
  const name = "hubspotutk=";
  const cookies = decodeURIComponent(document.cookie).split(";");
  for (let c of cookies) {
    c = c.trim();
    if (c.startsWith(name)) return c.substring(name.length);
  }
  return "";
};

const Home: React.FC<{}> = () => {
  const { afterCreate: translation } = translations.pages.bewerbung;
  const classes = useStyles({});

  const [state, setState] = useState<number | undefined>();
  const [error, setError] = useState<string | undefined>();
  const [docUpload] = useUploadDocumentsMutation();
  const [open, setOpen] = useState(false);
  const getUploadFile = useUploadfileTypeCallback();
  const persistData = async (id: number) => {
    const uploadFilePre = await getUploadFile();
    const documents = uploadFilePre?.uploadFiles.map<AttachementInput>((elem) => ({
      fileContent: elem.fileContent,
      bewerberId: id,
      fileTypeId: elem.uploadFileType,
      fileName: elem.name,
    }));

    try {
      await docUpload({
        variables: {
          documents: documents,
        },
      });
      setOpen(false);
      return true; // Success
    } catch (e) {
      console.error("Document upload error:", e);
      setError("Die Dokumente konnten nicht hochgeladen werden. Bitte versuchen Sie es später erneut.");
      setOpen(false);
      return false; // Failure
    }
  };
  const afterCreate = ({
    id,
    ...rest
  }: Data & {
    id: number;
  }) => {
    setOpen(true);
    setState(id);
    setError(undefined); // Reset error state

    client
      .mutate({ mutation: SendApplicationDocument, variables: { id } })
      .then(async (result) => {
        if (result.data.sendApplication.status === false) {
          // Handle error case when status is false
          setError("Die Bewerbung konnte nicht versendet werden. Bitte versuchen Sie es später erneut.");
          setOpen(false);
          return false;
        }
        return await persistData(id);
      })
      .then(async (persistResult) => {
        if (!persistResult) {
          console.warn("[Application] Document upload failed");
          
          return false;
        }

        return await callHubSpotApi({ id, ...rest });
      })
      .then((hubSpotResult) => {
        if (hubSpotResult) {
          window.localStorage.removeItem(localStorageKey);
        } else {
          console.warn("[Application] HubSpot submission failed, but application data persisted");
          setError("Die Bewerbung wurde eingereicht, aber die HubSpot-Synchronisierung ist fehlgeschlagen. Dies wird von unserem Team überprüft.");
          setOpen(false);
        }
      })
      .catch((error) => {
        console.error("[Application] Exception in submission process:", error);
        setError("Ein unerwarteter Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.");
        setOpen(false);
      });
  };

  const handleRetry = () => {
    setError(undefined);
    setState(undefined);
    // This will allow the user to go back to the form
  };

  return (
    <div className={classes.bewerberCreateFormBox}>
      {!state && !error && (
        <BewerberCreateForm onUpdateDataMiddleWare={onUpdateDataMiddleWare} afterCreate={afterCreate} />
      )}

      {/* Error State */}
      {error && (
        <div className={classes.errorContainer}>
          <ErrorOutlineIcon style={{ fontSize: "3em", color: "#d32f2f", marginBottom: "1em" }} />
          <Typography className={classes.errorHeadline}>Fehler beim Versenden der Bewerbung</Typography>
          <Typography className={classes.errorMessage}>{error}</Typography>
          <Button className={classes.retryButton} onClick={handleRetry} variant="contained">
            Erneut versuchen
          </Button>
        </div>
      )}

      {/* Success State */}
      {!!state && !error && (
        <div className={classes.afterCreate}>
          <Modal className={classes.modal} open={open}>
            <div className={classes.paper}>
              <Typography variant="h2">{translations.pages.bewerbung.afterCreate.processed}</Typography>
              <div className={classes.loader}>
                <CircularProgress className={classes.progress} size="70" />
              </div>
            </div>
          </Modal>
          <Helmet>
            <script async src="https://www.googletagmanager.com/gtag/js?id=AW-304155666" />
          </Helmet>
          <Helmet
            script={[
              {
                type: "text/javascript",
                innerHTML: `window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);};
     gtag('js', new Date());
      gtag('config', 'AW-304155666');
      gtag('event', 'conversion', {'send_to': 'AW-304155666/0CUDCL-XwZUDEJKYhJEB'});  `,
              },
            ]}
          />
          <div className={classes.svgContainer}>
            <CongratulationSVG />
          </div>
          <Typography className={classes.afterCreateHeadline}>{translation.headline}</Typography>
          <Typography className={classes.afterCreateSubHeadline}>{translation.subHeadline}</Typography>
          <Typography className={classes.afterCreateBody}>
            <p className={classes.noMargin}>{translation.body.part1}</p>
            <p className={classes.noMargin}>{translation.body.part2}</p>
          </Typography>
          <Typography className={classes.afterCreateBody}>{translation.greeting}</Typography>
          <div className={classes.linkContainer}>
            <EmailIcon style={{ fontSize: "2em", color: "#F59A12" }} />
            <Typography className={classes.linkTypography}>
              <a className={classes.link} href="mailto:studienberatung@kolping-hochschule.de">
                studienberatung@kolping-hochschule.de
              </a>
            </Typography>
          </div>
          <div className={classes.linkContainer}>
            <PhoneEnabledRoundedIcon style={{ fontSize: "2em", color: "#F59A12" }} />
            <Typography className={classes.linkTypography}>
              <a className={classes.link} href="tel:+4922171790990">
                +49 221 71790990
              </a>
            </Typography>
          </div>
        </div>
      )}
    </div>
  );
};

export default Home;
